module.exports = __webpack_public_path__ + "img/register_mb_04.35f4304c.png";